import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';

export const orgFr = createTranslationMessages({
  ref: orgTranslationRef,
  full: true,
  messages: {
    'groupProfileCard.groupNotFound': 'Groupe introuvable',
    'groupProfileCard.editIconButtonTitle': 'Modifier les métadonnées',
    'groupProfileCard.refreshIconButtonTitle':
      'Planifier l’actualisation de l’entité',
    'groupProfileCard.refreshIconButtonAriaLabel': 'Actualiser',
    'groupProfileCard.listItemTitle.email': 'E-mail',
    'groupProfileCard.listItemTitle.entityRef': 'Référence de l’entité',
    'groupProfileCard.listItemTitle.parentGroup': 'Groupe parent',
    'groupProfileCard.listItemTitle.childGroups': 'Groupes enfants',
    'membersListCard.title': 'Membres de {{groupName}}',
    'membersListCard.cardLabel': 'Page utilisateur de {{memberName}}',
    'membersListCard.noMembersDescription': 'Ce groupe n’a aucun membre.',
    'membersListCard.noSearchResult':
      'Aucun membre trouvé correspondant à « {{searchTerm}} ».',
    'membersListCard.aggregateMembersToggle.label':
      'Inclure les sous-groupes',
    'ownershipCard.title': 'Propriété',
    'ownershipCard.aggregateRelationsToggle.label':
      'Inclure la propriété indirecte',
    'userProfileCard.editIconButtonTitle': 'Modifier les métadonnées',
    'userProfileCard.listItemTitle.email': 'E-mail',
    'userProfileCard.listItemTitle.memberOf': 'Membre de',
    'userProfileCard.userNotFound': 'Utilisateur introuvable',
    'userProfileCard.moreGroupButtonTitle': '...Plus ({{number}})',
    'userProfileCard.allGroupDialog.title': 'Tous les groupes de {{name}} :',
    'userProfileCard.allGroupDialog.closeButtonTitle': 'Fermer',
  },
});
